<template>
  <VueSlickCarousel class="roadtrip__answers" v-bind="settings" :key="currentQuestion">
    <div
      class="roadtrip__answer"
      v-for="answer in questions[currentQuestion].answers"
      :key="answer.answer"
      :class="{
        'roadtrip__answer--nested-tick':
          (currentQuestion >= 1 && additionalQuestion === false) ||
          (additionalQuestion === true && currentQuestion >= 2),
      }"
    >
      <input
        type="radio"
        :id="answer.answer"
        :name="questions[currentQuestion].question"
        :value="answer.answer"
        :checked="answer.selected"
        @change="answered(answer)"
        :class="answer.selected ? 'checked' : null"
      />
      <label :for="answer.answer">
        <span class="roadtrip__answer-image" :class="'roadtrip__answer-image--' + answer.color">
          <img
            :src="'/Static/images/roadtrip/' + answer.image"
            :alt="answer.answer"
            class="roadstrip__image roadstrip__image--desktop"
          />
          <img
            :src="'/Static/images/roadtrip/mobile-only/' + answer.image"
            :alt="answer.answer"
            class="roadstrip__image roadstrip__image--mobile"
          />
        </span>
        <span class="roadtrip__answer-tick" :id="answer.answer">
          <span>{{ answer.answer }}</span>
        </span>
      </label>
    </div>
  </VueSlickCarousel>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'Answers',

  components: { VueSlickCarousel },

  data() {
    return {
      desktop: false,
      settings: {
        dots: true,
        responsive: [
          {
            breakpoint: 9999,
            settings: 'unslick',
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: false,
              arrows: false,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true,
              arrows: false,
            },
          },
        ],
      },
    };
  },
  created() {
    if (window.innerWidth > 991) {
      this.desktop = true;
    }
  },
  computed: {
    ...mapState('roadtrip', ['step', 'questions', 'currentQuestion', 'additionalQuestion']),
    ...mapGetters('roadtrip', ['chosenAnswer']),
  },

  methods: {
    answered: function (answer) {
      this.$store.commit('roadtrip/selectAnswer', answer);
    },
  },
};
</script>

<style scoped lang="scss">
.roadtrip__answers {
  margin-top: 2rem;
  margin-bottom: 2rem;

  @media only screen and (min-width: 992px) {
    margin-bottom: 6rem;
    margin-top: 6rem;
  }

  .roadtrip__answer {
    padding: 0 1.2rem;

    @media only screen and (min-width: 992px) {
      margin: 0 1.2rem;
      padding: 0;
      max-width: 285px;

      [data-answers-length='4'] & {
        max-width: 207px;
      }
      [data-answers-length='4'][data-current-question='0'] & {
        max-width: 170px;
      }
    }

    @media only screen and (min-width: 1200px) {
      max-width: 360px;

      [data-answers-length='4'] & {
        max-width: 264px;
      }
    }
  }
}

[data-current-question='0'] .roadtrip__answers {
  margin-bottom: 3rem;

  @media only screen and (min-width: 992px) {
    max-width: 820px;

    .roadtrip__answer-tick {
      span {
        font-size: 2.4rem;
        line-height: 2.4rem;
      }
    }
  }
}

[data-current-question='1'][data-answers-length='9'] .roadtrip__answers {
  max-width: 936px;
  margin-bottom: 2rem;
}

.roadtrip__answer {
  @media only screen and (min-width: 992px) {
    margin-top: 8rem;
  }
}

.roadtrip__answer:nth-last-child(n + 5),
.roadtrip__answer:nth-last-child(n + 5) ~ .roadtrip__answer {
  margin-bottom: 4.3rem;
}

.roadtrip__answer-image {
  display: inline-block;
  margin: 0 0 1.3rem;
  background: $white;
  border-radius: 10px;
}

.roadtrip__answer-image--grey {
  background: $grey-light;
}
.roadtrip__answer-image--white {
  background: $white;
}
.roadtrip__answer-image--black {
  background: $black;
}

.roadstrip__image--desktop {
  display: none;

  @media only screen and (min-width: 992px) {
    display: block;
  }
}

.roadstrip__image--mobile {
  display: block;

  @media only screen and (min-width: 992px) {
    display: none;
  }
}

[type='radio'] + label {
  display: block;

  @media only screen and (min-width: 992px) {
    display: inline-block;
  }

  @media only screen and (max-width: 991px) {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;

    .roadtrip__answer-image {
      margin: 0;
      display: block;
    }
    .roadtrip__answer-tick {
      border: 4px solid $black;
      border-top: 0;
      border-radius: 6px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      padding: 2.4rem 6.1rem 2.4rem 1.6rem;
      min-height: 10rem;
      display: flex;
      width: 100%;
      align-items: center;
      flex: 1;

      &::before {
        order: 1;
        margin: 0 0 0 auto;
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .roadtrip__answer-tick {
      border-width: 2px;
      padding: 1.6rem 6.1rem 1.6rem 1.6rem;
    }
  }
}

[type='radio'] + label .roadtrip__answer-tick::before {
  content: '';
  display: inline-block;
  width: 4.3rem;
  height: 4rem;
  background: url('~/images/roadtrip/radio.svg') no-repeat;
  margin: 0 auto;
  transition: 0.5s ease all;

  @media only screen and (max-width: 767px) {
    background: url('~/images/roadtrip/radio-mobile.svg') no-repeat;
  }
}

[type='radio']:checked + label .roadtrip__answer-tick::before {
  background: url('~/images/roadtrip/radio-selected.svg') no-repeat;

  @media only screen and (max-width: 767px) {
    background: url('~/images/roadtrip/radio-selected-mobile.svg') no-repeat;
  }
}

[type='radio']:checked + label .roadtrip__answer-image {
  position: relative;
  background: $green;

  @media only screen and (min-width: 992px) {
    &:after {
      content: '';
      position: absolute;
      top: 1rem;
      left: 1rem;
      display: block;
      width: 100%;
      height: 100%;
      background: url('~/images/roadtrip/dots.png') no-repeat;
      z-index: -1;
    }
  }
}

.roadtrip__answer-tick {
  display: block;

  @media only screen and (max-width: 991px) {
    text-align: left;
    padding-right: 6.1rem;
    position: relative;

    span {
      margin: 0;
      font-size: 2rem;
      line-height: 2.4rem;
    }

    &:before {
      position: absolute;
      top: 50%;
      right: 1.6rem;
      transform: translateY(-50%);
    }
  }
  @media only screen and (min-width: 992px) {
    span {
      display: block;
      margin: 1rem 0 0;
      font-size: 2rem;
      line-height: 2.4rem;
    }
  }
}

.roadtrip__answer--nested-tick .roadtrip__answer-tick {
  text-align: left;
  padding-right: 6.1rem;
  position: relative;

  span {
    margin: 0;
  }

  &:before {
    position: absolute;
    top: 50%;
    right: 1.6rem;
    transform: translateY(-50%);
  }
}

// question 3 onwards
.roadtrip__answer--nested-tick [type='radio'] + label {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;

  .roadtrip__answer-image {
    margin: 0;
  }
  @media only screen and (min-width: 992px) {
    .roadtrip__answer-tick {
      border: 4px solid $black;
      border-top: 0;
      border-radius: 6px;
      margin-top: -1rem;
      padding: 3.4rem 6.1rem 3.4rem 1.6rem;
      display: flex;
      width: 100%;
      align-items: center;

      &::before {
        order: 1;
        margin: 0 0 0 auto;
      }
    }
  }
}

[data-answers-length='2'] .roadtrip__answers {
  max-width: 1152px;

  .roadtrip__answer {
    @media only screen and (min-width: 992px) {
      max-width: 439px;
    }

    @media only screen and (min-width: 1200px) {
      max-width: 552px;
    }
  }
  .roadtrip__answer--nested-tick .roadtrip__answer-tick {
    min-height: 118px;
  }
}
</style>
